import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Outlet, useParams, useSearchParams } from 'react-router-dom'
import CardCustom from '../../components/custom/card-custom'
import NavbarMain from '../../components/employees/pim-detail/navbar-main'
import BtnBack from '../../components/btn-back'
import { PIM_EMP } from '../../router/routes'
import NavTitle from '../../components/nav-title'
import {
  getEmployeeLookupByIdAPI,
  getEmpsDetailsByUUIDAPI
} from '../../services/employee'
import { useDispatch, useSelector } from 'react-redux'
import { updateProfileID } from '../../actions/profile.action'

function PimEmployeeDetail() {
  const { id } = useParams()
  const [dataUser, setDataUser] = useState()
  const { profile } = useSelector((state) => state.profileReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchData = async () => {
      const resp_full = await getEmpsDetailsByUUIDAPI({ uuid: id })
      const resp_mini = await getEmployeeLookupByIdAPI({ key: id })

      if (!resp_full) return
      if (!resp_mini) return
      if (resp_full.status) {
        setDataUser(resp_mini.result)
        dispatch(updateProfileID({ ...resp_full.result, ...resp_mini.result }))
      } else {
        setDataUser()
        dispatch(updateProfileID(null))
      }
    }
    fetchData()
  }, [dispatch, id])

  // useEffect(() => {
  //   const fnGetData = async () => {
  //     try {
  //       const resp = await getEmployeeLookupByIdAPI({ key: id })
  //       if (!resp) return
  //       if (resp.status) {
  //         setDataUser(resp.result)
  //         dispatch(updateProfileID({ ...resp.result, ...profile }))
  //       } else {
  //         setDataUser()
  //         dispatch(updateProfileID(null))
  //       }
  //     } catch (error) {
  //       setDataUser()
  //     }
  //   }

  //   if (id) {
  //     fnGetData()
  //   }
  // }, [dispatch, id])

  return (
    <Row>
      <NavTitle>
        <BtnBack
          to={PIM_EMP}
          text={`${profile?.name_en} ${profile?.surname_en}`}
          className={'text-muted'}
        />
      </NavTitle>

      <Col xl={12}>
        <CardCustom
          style={{
            height: 'calc(100vh - 65px'
          }}
        >
          <NavbarMain />
          <Outlet context={{ dataUser }} />
        </CardCustom>
      </Col>
    </Row>
  )
}

export default PimEmployeeDetail
